import { c as _c } from "react/compiler-runtime";
import { cva } from "class-variance-authority";
import type { VariantProps } from "class-variance-authority";
import cn from "twsx";
const spinnerPixelSizes = {
  xs: 12,
  sm: 14,
  md: 16,
  lg: 20,
  xl: 24,
  "2xl": 32
} as const;
const spinnerVariants = cva("shrink-0 animate-spin motion-reduce:animate-none", {
  variants: {
    tone: {
      current: "",
      secondary: "text-text-secondary",
      muted: "text-text-tertiary",
      faint: "text-text-quaternary"
    }
  },
  defaultVariants: {
    tone: "current"
  }
});
export type SpinnerProps = Omit<React.SVGProps<SVGSVGElement>, "width" | "height"> & VariantProps<typeof spinnerVariants> & {
  size?: keyof typeof spinnerPixelSizes;
};

/** Use when an action or region is busy and its shape is unknown. */
export const Spinner = function Spinner(t0) {
  const $ = _c(13);
  let className;
  let props;
  let t1;
  let tone;
  if ($[0] !== t0) {
    ({
      size: t1,
      tone,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
    $[4] = tone;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
    tone = $[4];
  }
  const size = t1 === undefined ? "xl" : t1;
  const pixels = spinnerPixelSizes[size];
  let t2;
  if ($[5] !== className || $[6] !== tone) {
    t2 = cn(spinnerVariants({
      tone
    }), className);
    $[5] = className;
    $[6] = tone;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path d="M21 12a9 9 0 1 1-6.219-8.56" />;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== pixels || $[10] !== props || $[11] !== t2) {
    t4 = <svg xmlns="http://www.w3.org/2000/svg" width={pixels} height={pixels} {...props} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={t2}>{t3}</svg>;
    $[9] = pixels;
    $[10] = props;
    $[11] = t2;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
};
Spinner.displayName = "Spinner";